<template>
  <div class="order">
    <div class="card" @click="getLoad" v-for="i in form" :key="i.id">
      <div class="inner">
        <p class="name"><a>{{ i.nickName }}</a><span
            :style="i.state===1?'background-color: #2985E8':'background-color: #F2B60A;'"> {{ i.state === 1 ? '未检测' : '已出报告' }}</span></p>
        <p>身份证号:{{ i.idCard }}</p>
        <p>手机号码:{{ i.phone }}</p>
        <p>预约时间:{{ i.appointmentTime }}</p>
        <p>采样点:{{ i.addr }}</p></div>
      <div class="end"  v-if="i.state === 1">
        <!--  预约码-->
        <h4>预约码:{{ i.appointCode }}</h4>
        <barcode class=" codeShow" v-model="i.appointCode"/>
        <img src="../assets/image/shouldknow.png" alt="">
        <div class="shouldkown">
          <p><span>1</span> <i>采样时须携带本人身份证或护照，核对信息后方可采样；</i></p>
          <p><span>2</span><i>咽拭子采样前提前漱口或30分钟内勿进食；</i></p>
          <p><span>3</span><i>可出具电子版盖章报告；</i></p>
          <p><span>4</span><i>可开具发票，详情请电话联系客服。</i></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import {getDetail} from '@/api/order/index.js';

export default {
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F4F4F4');
  },
  components: {
    'barcode': VueBarcode
  },
  name: "Order",
  data() {
    return {
      // form: {
      //   nickName: "",
      //   phone: "",
      //   age:'',
      //   addr:'',
      //   state:'',
      //   appointmentTime:'',
      //   appointCode:''
      // },
      form: [
         // openId:'AA123456'
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const data = {
        nickName: this.$route.query.nickName,
        phone: this.$route.query.phone,
        openId:this.$route.query.openId,
      };
      getDetail(data).then(res => {
        this.form = res.data.data;
        if (this.form.length === 0) {
          this.$toast('没有您的预约信息!');
         setTimeout(()=>{
           this.$router.go(-1)
         },1000)
        }
      });


    },
    getLoad() {
      console.log(this.form);
      this.$router.push({path: 'register'});
    }
    // 没预约

  }

};
</script>

<style scoped lang='less'>

.order {
  width: 750px;
  height: 100%;
  background-color: #F4F4F4;
}

.card {
  width: 690px;
  background-color: #ffffff;
  border-bottom: 5px;
  border-radius: 20px;
  margin: 40px auto;
  border-bottom: 10px solid #2985E8;

  padding: 20px 0;

  a {
    font-size: 47px;
    color: #2985E8;
  }

  span {
    padding: 7px;
    background-color: #007Aff;
    border-radius: 10px;
    color: #fff;
    margin-left: 20px;;
  }

  .inner {
    margin: 40px;
    font-size: 28px;
    //border-bottom: 1px solid #0C7FD8;
    //padding-bottom: 60px;
    p{
      font-size: 38px;
      span{
        font-size: 26px;
      }
    }

    .top {
      margin-top: 20px;
    }
  }
}

.already {
  background-color: #2985E8;
}

.unready {
  background-color: #F2B60A;
}

.end {
  width: 690px;
  background-color: #fff;
  margin: 0 auto;
  border-radius: 10px;
  padding: 40px 0;

  h4 {
    font-size: 45px;
    width: 100%;
    color: #007AFF;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }

  img {
    margin: 40px 173px 0 173px;
    width: 345px;

  }

  p {
    font-size: 24px;

  }

}

.codeShow {
  display: flex;
  justify-content: center;
  margin-top: -20px;
}

.shouldkown {

  p {
    font-size: 24px;
    padding: 5px;
    text-align: justify;
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      width: 20px;
      height: 20px;
      background-color: #007Aff;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      margin: 0 10px 0 30px;
    }

    i {
      padding-right: 30px;
      font-size: 20px;
    }
  }
}

.name {
  display: flex;
  align-items: center;
}

.display {
  display: none;
}


</style>
